export default __webpack_public_path__ + "static/media/lastcard.ef575f32.svg";